import { StockVm } from "../stocks/stockVm"
import { INutritionPlanProductApp, INutritionService } from "../types"
import { sortReferenceDates } from "../utils"
import { ApplicationVm } from "./applicationVm"

export function getApplicationViewModels(applications: INutritionPlanProductApp[], svc: INutritionService, stocks: StockVm[]) {

    return applications
        .map(a => {

            const { FertiliserId: fertiliserId, ManureId: manureId } = a

            const stock = stocks.find(s => s.checkId(fertiliserId, manureId))

            return new ApplicationVm(a, stock, svc)

        })
        .sort((a1, a2) => sortReferenceDates(a1, a2))
}
